/**
 * Flatten module sections into a single linear array of slide/quiz items.
 * Used by the module player to drive a single forward/back nav.
 */
export function flattenSlides(moduleData) {
  const slides = [];
  (moduleData?.sections || []).forEach((s) => {
    if (s.section_type === 'quiz') {
      slides.push({ type: 'quiz', section: s, quiz_id: s.quiz_id, sectionTitle: s.title });
    } else {
      (s.slides || []).forEach((sl) => slides.push({
        type: 'slide', slide: sl, section: s, sectionTitle: s.title,
      }));
    }
  });
  return slides;
}
